<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useThemeStore } from '@/stores/theme'

const { t, locale } = useI18n()
const theme = useThemeStore()

function toggleLang() {
  locale.value = locale.value === 'en' ? 'ar' : 'en'
}
</script>

<template>
  <div class="min-h-screen flex flex-col bg-background-light dark:bg-background-dark">
    <header class="flex items-center justify-between px-4 py-4 max-w-md mx-auto w-full">
      <RouterLink to="/" class="flex items-center gap-2 font-display font-bold text-lg text-primary">
        <span class="text-xl">🕌</span>
        <span>{{ t('app.name') }}</span>
      </RouterLink>
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="p-2 rounded-xl text-text-secondary-light dark:text-text-secondary-dark hover:text-primary hover:bg-primary/10 transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
          :aria-label="theme.isDark ? 'Light mode' : 'Dark mode'"
          @click="theme.toggle()"
        >
          <span class="material-symbols-outlined text-2xl">{{ theme.isDark ? 'light_mode' : 'dark_mode' }}</span>
        </button>
        <button type="button" @click="toggleLang" class="px-3 py-1.5 rounded-xl text-xs font-semibold border border-gray-200 dark:border-gray-700 bg-surface-light dark:bg-surface-dark text-text-primary-light dark:text-text-primary-dark hover:border-primary">
          {{ locale === 'en' ? 'العربية' : 'English' }}
        </button>
      </div>
    </header>

    <main class="flex-1 flex items-center justify-center p-6">
      <RouterView />
    </main>

    <footer class="text-center py-4 text-sm text-text-secondary-light dark:text-text-secondary-dark">
      <p>© 2026 {{ t('app.name') }}</p>
    </footer>
  </div>
</template>
